const cartTypes = {
  ADD_TO_CART: "ADD_TO_CART",
  REMOVE_CART_ITEM: "REMOVE_CART_ITEM",
  UPDATE_CART: "UPDATE_CART",
};

export default cartTypes;
